import React, { Component } from 'react';
import PropTypes from 'prop-types';
import apiRequest from '../utils/apiRequest';
import BookSheet from './BookSheet';
import {
  Card,
  CardContent,
  CardSpacing,
  SecondaryTitle
} from './CommonUiComponents';
import ErrorBoundary from './ErrorBoundary';

class Sheets extends Component {
  state = {
    sheets: []
  };

  componentDidMount() {
    this.fetchSheets();
  }

  fetchSheets = async () => {
    const { book } = this.props;

    const response = await apiRequest(
      'wordpress',
      `bookdata/v1/sheets?id=${book}`
    );

    this.setState({
      sheets: response
    });
  };

  render() {
    const { invertedTheme } = this.props;
    const { sheets } = this.state;

    if (!sheets) return null;

    return (
      <Card>
        <ErrorBoundary>
          <CardSpacing>
            <CardContent>
              <CardSpacing hugger>
                <SecondaryTitle inverted={invertedTheme}>
                  Materiell
                </SecondaryTitle>
              </CardSpacing>
              <BookSheet inverted={invertedTheme} sheets={sheets} />
            </CardContent>
          </CardSpacing>
        </ErrorBoundary>
      </Card>
    );
  }
}

Sheets.propTypes = {
  book: PropTypes.number.isRequired,
  invertedTheme: PropTypes.bool.isRequired
};

export default Sheets;



// WEBPACK FOOTER //
// ./src/components/Sheets.js